import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Clients from "../admin/Users";
import Meetings from "../admin/Meetings";
import Apps from "../admin/Apps";
import Credits from "../admin/Credits";
import Logs from "../admin/Logs";
import Agents from "../admin/Agents";
import AgentDetail from "../admin/AgentDetail";
import NotFound from "../components/common/NotFound";
import Participants from "../admin/Participants";
import Activities from "../admin/Activities";
import MeetingDetail from "../admin/MeetingDetail";
import Payments from "../admin/Payments";
import Integrations from "../admin/Integrations";

const Layout = () => (
  <>
    <Header />
    <div className="d-flex">
      <div className="sidebar-container col-auto">
        <Sidebar />
      </div>
      <div className="col py-3">
        <Outlet />
      </div>
    </div>
  </>
);

const Admin = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Navigate to="users" replace />} />
      <Route path="users" element={<Clients />} />
      <Route path="agents" element={<Agents />} />
      <Route path="meetings" element={<Meetings />} />
      <Route path="apps" element={<Apps />} />
      <Route path="participants" element={<Participants />} />
      <Route path="activities" element={<Activities />} />
      <Route path="integrations" element={<Integrations />} />
      <Route path="credits" element={<Credits />} />
      <Route path="payments" element={<Payments />} />
      <Route path="assistant/:assistant/logs" element={<Logs />} />
      <Route path="agents/:uuid" element={<AgentDetail />} />
      <Route path="meetings/:uuid" element={<MeetingDetail />} />
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default Admin;

